<script lang='ts'>
    import lang from '../lang/language';
</script>

<div class='under-maintenance-message'>
    <h2>{@html lang.under_maintenance}</h2>
</div>

<style>
    .under-maintenance-message {
        text-align: center;
        line-height: 200px;
    }
</style>